<template>
    <div class="accountsReceiveDataSource">
        <!--顶部按钮部分-->
        <div class="btns">
            <el-button type="primary" @click="deleteData">删除</el-button>
            <el-button type="primary" @click="exportExcele">导出</el-button>
            <el-button title="导入" type="primary" @click="importSubEngineer()">导入</el-button>
            <el-button type="primary" @click="exportPlatform">下载模板</el-button>
            <!--            <el-button type="primary" @click="downLoadExcel">下载模板</el-button>-->
        </div>
        <!--日期切换部分-->
        <el-form :inline="true" :model="searchForm" ref="accountsReceiveDataSourceForm">
            <el-form-item label="日期切换">
                <el-date-picker
                        v-model="searchForm.enterDate"
                        value-format="yyyy-MM-dd"
                        type="date"
                        :picker-options="pickerOptions"
                        placeholder="请切换日期"
                        :clearable="false"
                ></el-date-picker>
            </el-form-item>
            <el-form-item label="项目部" prop="deptName">
                <el-select v-model="searchForm.deptName" placeholder="请选择" clearable>
                    <el-option v-for="item in deptNameList" :key="item" :label="item" :value="item"></el-option>
                </el-select>
            </el-form-item>
            <el-button type="primary" @click="search">查询</el-button>
            <el-button type="primary" @click="resetData">重置</el-button>
        </el-form>
        <!--        表格数据部分-->
        <div class="mainContentWrap">
            <div class="mainContent">
                <div class="cardBox" v-if="!projectReceiveSubVOList||projectReceiveSubVOList.length<1">
                    <el-table
                            :data="emptyData"
                            show-summary
                            :summary-method="getSummaries"
                            sum-text="小计"
                            style="width: 100%"
                    >
                        <el-table-column label="序号" align="right" header-align="center" width="50">
                            <template slot-scope="scope">{{scope.$index + 1}}</template>
                        </el-table-column>
                        <el-table-column
                                prop="projectName"
                                label="项目名称"
                                align="center"
                                header-align="center"
                                width="70"
                        ></el-table-column>
                        <el-table-column
                                prop="debtCompany"
                                label="欠款单位"
                                align="center"
                                header-align="center"
                                width="70"
                        ></el-table-column>
                        <el-table-column
                                prop="auditSituation"
                                label="审计及竣工情况"
                                align="center"
                                header-align="center"
                                width="110"
                        ></el-table-column>
                        <el-table-column
                                prop="auditAmount"
                                label="审计额或已完产值"
                                align="center"
                                header-align="center"
                                width="120"
                        >
                            <template slot-scope="scope">
                                {{formatCurrency(scope.row[scope.column.property])}}
                            </template>
                        </el-table-column>
                        <el-table-column
                                prop="collectedMoney"
                                label="已收款"
                                align="center"
                                header-align="center"
                                width="100"
                        >
                            <template slot-scope="scope">
                                {{formatCurrency(scope.row[scope.column.property])}}
                            </template>
                        </el-table-column>
                        <el-table-column
                                prop="debtTotalMoney"
                                label="应收账款"
                                align="center"
                                header-align="center"
                                width="90"
                        >
                            <template slot-scope="scope">
                                {{formatCurrency(scope.row[scope.column.property])}}
                            </template>
                        </el-table-column>
                        <el-table-column label="欠款金额明细分析">
                            <el-table-column
                                    prop="retentionMoney"
                                    label="质保金"
                                    align="center"
                                    header-align="center"
                                    width="70"
                            >
                                <template slot-scope="scope">
                                    {{formatCurrency(scope.row[scope.column.property])}}
                                </template>
                            </el-table-column>
                            <el-table-column
                                    prop="projectMoney"
                                    label="需交工验收、审计、竣工验收后应支付工程款(不含质保金)"
                                    align="center"
                                    header-align="center"
                                    :render-header="renderheader"
                                    width="150"
                            >
                                <template slot-scope="scope">
                                    {{formatCurrency(scope.row[scope.column.property])}}
                                </template>
                            </el-table-column>
                            <el-table-column
                                    prop="processMoney"
                                    label="按进度应支付工程款(欠款总额-质保金-需交工验收、审计、竣工验收后应支付工程款)"
                                    align="center"
                                    header-align="center"
                                    width="190"
                            >
                                <template slot-scope="scope">
                                    {{formatCurrency(scope.row[scope.column.property])}}
                                </template>
                            </el-table-column>
                        </el-table-column>
                        <el-table-column label="按账龄划分金额">
                            <el-table-column
                                    prop="withinOneYear"
                                    label="1年以内"
                                    align="center"
                                    header-align="center"
                                    width="70"
                            >
                                <template slot-scope="scope">
                                    {{formatCurrency(scope.row[scope.column.property])}}
                                </template>
                            </el-table-column>
                            <el-table-column
                                    prop="oneToTwo"
                                    label="1-2年"
                                    align="center"
                                    header-align="center"
                                    width="60"
                            >
                                <template slot-scope="scope">
                                    {{formatCurrency(scope.row[scope.column.property])}}
                                </template>
                            </el-table-column>
                            <el-table-column
                                    prop="twoToThree"
                                    label="2-3年"
                                    align="center"
                                    header-align="center"
                                    width="60"
                            >
                                <template slot-scope="scope">
                                    {{formatCurrency(scope.row[scope.column.property])}}
                                </template>
                            </el-table-column>
                            <el-table-column
                                    prop="beyondThree"
                                    label="3年(含)以上"
                                    align="center"
                                    header-align="center"
                                    width="90"
                            ></el-table-column>
                        </el-table-column>
                        <el-table-column
                                prop="backDate"
                                label="内容/(应返还时间)"
                                align="center"
                                :render-header="renderheader"
                                header-align="center"
                                width="90"
                        ></el-table-column>
                        <el-table-column label="欠款未返还原因及工作推进情况">
                            <el-table-column
                                    prop="debtReason"
                                    label="预计进展情况"
                                    align="center"
                                    header-align="center"
                                    width="190"
                            ></el-table-column>
                        </el-table-column>
                        <el-table-column
                                prop="backExpectAmount"
                                label="任务目标/(预计收回金额)"
                                :render-header="renderheader"
                                align="center"
                                header-align="center"
                                width="130"
                        >
                            <template slot-scope="scope">
                                {{formatCurrency(scope.row[scope.column.property])}}
                            </template>
                        </el-table-column>
                        <el-table-column
                                prop="chargeUserName"
                                label="责任人"
                                align="center"
                                header-align="center"
                                width="60"
                        ></el-table-column>
                        <el-table-column
                                prop="backExpectDate"
                                label="预计回收时间"
                                align="center"
                                header-align="center"
                                width="100"
                        ></el-table-column>
                        <el-table-column
                                prop="backExpectPct"
                                label="回收比例"
                                align="center"
                                header-align="center"
                                width="80"
                        ></el-table-column>
                        <el-table-column
                                prop="comment"
                                label="备注"
                                align="center"
                                header-align="center"
                                width="100"
                        ></el-table-column>
                        <el-table-column
                                prop="checkInfo"
                                label="导入标识"
                                align="center"
                                header-align="center"
                                width="80"
                        ></el-table-column>
                    </el-table>
                </div>


                <div class="cardBox" v-for="(item,index) in projectReceiveSubVOList" :key="index">
                    <el-button type="primary">{{item.deptName}}</el-button>
                    <el-table
                            :data="item.projectReceiveVO"
                            show-summary
                            :summary-method="getSummaries"
                            sum-text="小计"
                            style="width: 100%"
                    >
                        <el-table-column label="序号" align="right" header-align="center" width="50">
                            <template slot-scope="scope">{{scope.$index + 1}}</template>
                        </el-table-column>
                        <el-table-column
                                prop="projectName"
                                label="项目名称"
                                align="center"
                                header-align="center"
                                width="70"
                        ></el-table-column>
                        <el-table-column
                                prop="debtCompany"
                                label="欠款单位"
                                align="center"
                                header-align="center"
                                width="70"
                        ></el-table-column>
                        <el-table-column
                                prop="auditSituation"
                                label="审计及竣工情况"
                                align="center"
                                header-align="center"
                                width="110"
                        ></el-table-column>
                        <el-table-column
                                prop="auditAmount"
                                label="审计额或已完产值"
                                align="center"
                                header-align="center"
                                width="120"
                        >
                            <template slot-scope="scope">
                                {{formatCurrency(scope.row[scope.column.property])}}
                            </template>
                        </el-table-column>
                        <el-table-column
                                prop="collectedMoney"
                                label="已收款"
                                align="center"
                                header-align="center"
                                width="100"
                        >
                            <template slot-scope="scope">
                                {{formatCurrency(scope.row[scope.column.property])}}
                            </template>
                        </el-table-column>
                        <el-table-column
                                prop="debtTotalMoney"
                                label="应收账款"
                                align="center"
                                header-align="center"
                                width="90"
                        >
                            <template slot-scope="scope">
                                {{formatCurrency(scope.row[scope.column.property])}}
                            </template>
                        </el-table-column>
                        <el-table-column label="欠款金额明细分析">
                            <el-table-column
                                    prop="retentionMoney"
                                    label="质保金"
                                    align="center"
                                    header-align="center"
                                    width="70"
                            >
                                <template slot-scope="scope">
                                    {{formatCurrency(scope.row[scope.column.property])}}
                                </template>
                            </el-table-column>
                            <el-table-column
                                    prop="projectMoney"
                                    label="需交工验收、审计、竣工验收后应支付工程款(不含质保金)"
                                    align="center"
                                    header-align="center"
                                    :render-header="renderheader"
                                    width="150"
                            >
                                <template slot-scope="scope">
                                    {{formatCurrency(scope.row[scope.column.property])}}
                                </template>
                            </el-table-column>
                            <el-table-column
                                    prop="processMoney"
                                    label="按进度应支付工程款(欠款总额-质保金-需交工验收、审计、竣工验收后应支付工程款)"
                                    align="center"
                                    header-align="center"
                                    width="190"
                            >
                                <template slot-scope="scope">
                                    {{formatCurrency(scope.row[scope.column.property])}}
                                </template>
                            </el-table-column>
                        </el-table-column>
                        <el-table-column label="按账龄划分金额">
                            <el-table-column
                                    prop="withinOneYear"
                                    label="1年以内"
                                    align="center"
                                    header-align="center"
                                    width="70"
                            >
                                <template slot-scope="scope">
                                    {{formatCurrency(scope.row[scope.column.property])}}
                                </template>
                            </el-table-column>
                            <el-table-column
                                    prop="oneToTwo"
                                    label="1-2年"
                                    align="center"
                                    header-align="center"
                                    width="60"
                            >
                                <template slot-scope="scope">
                                    {{formatCurrency(scope.row[scope.column.property])}}
                                </template>
                            </el-table-column>
                            <el-table-column
                                    prop="twoToThree"
                                    label="2-3年"
                                    align="center"
                                    header-align="center"
                                    width="60"
                            >
                                <template slot-scope="scope">
                                    {{formatCurrency(scope.row[scope.column.property])}}
                                </template>
                            </el-table-column>
                            <el-table-column
                                    prop="beyondThree"
                                    label="3年(含)以上"
                                    align="center"
                                    header-align="center"
                                    width="90"
                            ></el-table-column>
                        </el-table-column>
                        <el-table-column
                                prop="backDate"
                                label="内容/(应返还时间)"
                                align="center"
                                :render-header="renderheader"
                                header-align="center"
                                width="90"
                        ></el-table-column>
                        <el-table-column label="欠款未返还原因及工作推进情况">
                            <el-table-column
                                    prop="debtReason"
                                    label="预计进展情况"
                                    align="center"
                                    header-align="center"
                                    width="190"
                            ></el-table-column>
                        </el-table-column>
                        <el-table-column
                                prop="backExpectAmount"
                                label="任务目标/(预计收回金额)"
                                :render-header="renderheader"
                                align="center"
                                header-align="center"
                                width="130"
                        >
                            <template slot-scope="scope">
                                {{formatCurrency(scope.row[scope.column.property])}}
                            </template>
                        </el-table-column>
                        <el-table-column
                                prop="chargeUserName"
                                label="责任人"
                                align="center"
                                header-align="center"
                                width="60"
                        ></el-table-column>
                        <el-table-column
                                prop="backExpectDate"
                                label="预计回收时间"
                                align="center"
                                header-align="center"
                                width="100"
                        ></el-table-column>
                        <el-table-column
                                prop="backExpectPct"
                                label="回收比例"
                                align="center"
                                header-align="center"
                                width="80"
                        ></el-table-column>
                        <el-table-column
                                prop="comment"
                                label="备注"
                                align="center"
                                header-align="center"
                                width="100"
                        ></el-table-column>
                        <el-table-column
                                prop="checkInfo"
                                label="导入标识"
                                align="center"
                                header-align="center"
                                width="80"
                        ></el-table-column>
                    </el-table>
                </div>
                <div class="cardBox sumBox">
                    <el-table :data="sumTableData" :show-header="false" style="width: 100%">
                        <el-table-column label="序号" align="center" header-align="center" width="50">
                            <template>汇总</template>
                        </el-table-column>
                        <el-table-column
                                prop="projectName"
                                label="项目名称"
                                align="center"
                                header-align="center"
                                width="70"
                        ></el-table-column>
                        <el-table-column
                                prop="debtCompany"
                                label="欠款单位"
                                align="center"
                                header-align="center"
                                width="70"
                        ></el-table-column>
                        <el-table-column
                                prop="auditSituation"
                                label="审计及竣工情况"
                                align="center"
                                header-align="center"
                                width="110"
                        ></el-table-column>
                        <el-table-column
                                prop="auditAmount"
                                label="审计额或已完产值"
                                align="center"
                                header-align="center"
                                width="120"
                        ></el-table-column>
                        <el-table-column
                                prop="collectedMoney"
                                label="已收款"
                                align="center"
                                header-align="center"
                                width="100"
                        ></el-table-column>
                        <el-table-column
                                prop="debtTotalMoney"
                                label="应收账款"
                                align="center"
                                header-align="center"
                                width="90"
                        ></el-table-column>
                        <el-table-column label="欠款金额明细分析">
                            <el-table-column
                                    prop="retentionMoney"
                                    label="质保金"
                                    align="center"
                                    header-align="center"
                                    width="70"
                            ></el-table-column>
                            <el-table-column
                                    prop="projectMoney"
                                    label="需交工验收、审计、竣工验收后应支付工程款(不含质保金)"
                                    align="center"
                                    header-align="center"
                                    :render-header="renderheader"
                                    width="150"
                            ></el-table-column>
                            <el-table-column
                                    prop="processMoney"
                                    label="按进度应支付工程款(欠款总额-质保金-需交工验收、审计、竣工验收后应支付工程款)"
                                    align="center"
                                    header-align="center"
                                    width="190"
                            ></el-table-column>
                        </el-table-column>
                        <el-table-column label="按账龄划分金额">
                            <el-table-column
                                    prop="withinOneYear"
                                    label="1年以内"
                                    align="center"
                                    header-align="center"
                                    width="70"
                            ></el-table-column>
                            <el-table-column
                                    prop="oneToTwo"
                                    label="1-2年"
                                    align="center"
                                    header-align="center"
                                    width="60"
                            ></el-table-column>
                            <el-table-column
                                    prop="twoToThree"
                                    label="2-3年"
                                    align="center"
                                    header-align="center"
                                    width="60"
                            ></el-table-column>
                            <el-table-column
                                    prop="beyondThree"
                                    label="3年(含)以上"
                                    align="center"
                                    header-align="center"
                                    width="90"
                            ></el-table-column>
                        </el-table-column>
                        <el-table-column
                                prop="backDate"
                                label="内容/(应返还时间)"
                                align="center"
                                :render-header="renderheader"
                                header-align="center"
                                width="90"
                        ></el-table-column>
                        <el-table-column label="欠款未返还原因及工作推进情况">
                            <el-table-column
                                    prop="debtReason"
                                    label="预计进展情况"
                                    align="center"
                                    header-align="center"
                                    width="190"
                            ></el-table-column>
                        </el-table-column>
                        <el-table-column
                                prop="backExpectAmount"
                                label="任务目标/(预计收回金额)"
                                :render-header="renderheader"
                                align="center"
                                header-align="center"
                                width="130"
                        ></el-table-column>
                        <el-table-column
                                prop="chargeUserName"
                                label="责任人"
                                align="center"
                                header-align="center"
                                width="60"
                        ></el-table-column>
                        <el-table-column
                                prop="backExpectDate"
                                label="预计回收时间"
                                align="center"
                                header-align="center"
                                width="100"
                        ></el-table-column>
                        <el-table-column
                                prop="backExpectPct"
                                label="回收比例"
                                align="center"
                                header-align="center"
                                width="80"
                        ></el-table-column>
                        <el-table-column
                                prop="comment"
                                label="备注"
                                align="center"
                                header-align="center"
                                width="100"
                        ></el-table-column>
                        <el-table-column
                                prop="checkInfo"
                                label="导入标识"
                                align="center"
                                header-align="center"
                                width="80"
                        ></el-table-column>
                    </el-table>
                </div>
            </div>
        </div>
        <!-- 导入成功之后的弹窗-->
        <div class="dialogWrap">
            <el-dialog title="提示" :visible.sync="dialogVisible" width="80%">
                <div class="cardBox">
                    <el-table :data="dialogData" border fit style="width: 100%">
                        <el-table-column label="序号" align="right" header-align="center" width="50">
                            <template slot-scope="scope">{{scope.$index + 1}}</template>
                        </el-table-column>
                        <el-table-column
                                prop="checkInfo"
                                label="校验结果"
                                align="center"
                                header-align="center"
                                width="70"
                        ></el-table-column>
                        <el-table-column
                                prop="projectName"
                                label="项目名称"
                                align="center"
                                header-align="center"
                                width="70"
                        ></el-table-column>
                        <el-table-column
                                prop="debtCompany"
                                label="欠款单位"
                                align="center"
                                header-align="center"
                                width="70"
                        ></el-table-column>
                        <el-table-column
                                prop="auditSituation"
                                label="审计及竣工情况"
                                align="center"
                                header-align="center"
                                width="110"
                        ></el-table-column>
                        <el-table-column
                                prop="auditAmount"
                                label="审计额或已完产值"
                                align="center"
                                header-align="center"
                                width="120"
                        >
                            <template slot-scope="scope">
                                {{formatCurrency(scope.row[scope.column.property])}}
                            </template>
                        </el-table-column>
                        <el-table-column
                                prop="collectedMoney"
                                label="已收款"
                                align="center"
                                header-align="center"
                                width="100"
                        >
                            <template slot-scope="scope">
                                {{formatCurrency(scope.row[scope.column.property])}}
                            </template>
                        </el-table-column>
                        <el-table-column
                                prop="debtTotalMoney"
                                label="应收账款"
                                align="center"
                                header-align="center"
                                width="90"
                        >
                            <template slot-scope="scope">
                                {{formatCurrency(scope.row[scope.column.property])}}
                            </template>
                        </el-table-column>
                        <el-table-column label="欠款金额明细分析">
                            <el-table-column
                                    prop="retentionMoney"
                                    label="质保金"
                                    align="center"
                                    header-align="center"
                                    width="70"
                            >
                                <template slot-scope="scope">
                                    {{formatCurrency(scope.row[scope.column.property])}}
                                </template>
                            </el-table-column>
                            <el-table-column
                                    prop="projectMoney"
                                    label="需交工验收、审计、竣工验收后应支付工程款(不含质保金)"
                                    align="center"
                                    header-align="center"
                                    :render-header="renderheader"
                                    width="150"
                            >
                                <template slot-scope="scope">
                                    {{formatCurrency(scope.row[scope.column.property])}}
                                </template>
                            </el-table-column>
                            <el-table-column
                                    prop="processMoney"
                                    label="按进度应支付工程款(欠款总额-质保金-需交工验收、审计、竣工验收后应支付工程款)"
                                    align="center"
                                    header-align="center"
                                    width="190"
                            >
                                <template slot-scope="scope">
                                    {{formatCurrency(scope.row[scope.column.property])}}
                                </template>
                            </el-table-column>
                        </el-table-column>
                        <el-table-column label="按账龄划分金额">
                            <el-table-column
                                    prop="withinOneYear"
                                    label="1年以内"
                                    align="center"
                                    header-align="center"
                                    width="70"
                            >
                                <template slot-scope="scope">
                                    {{formatCurrency(scope.row[scope.column.property])}}
                                </template>
                            </el-table-column>
                            <el-table-column
                                    prop="oneToTwo"
                                    label="1-2年"
                                    align="center"
                                    header-align="center"
                                    width="60"
                            >
                                <template slot-scope="scope">
                                    {{formatCurrency(scope.row[scope.column.property])}}
                                </template>
                            </el-table-column>
                            <el-table-column
                                    prop="twoToThree"
                                    label="2-3年"
                                    align="center"
                                    header-align="center"
                                    width="60"
                            >
                                <template slot-scope="scope">
                                    {{formatCurrency(scope.row[scope.column.property])}}
                                </template>
                            </el-table-column>
                            <el-table-column
                                    prop="beyondThree"
                                    label="3年(含)以上"
                                    align="center"
                                    header-align="center"
                                    width="90"
                            >
                                <template slot-scope="scope">
                                    {{formatCurrency(scope.row[scope.column.property])}}
                                </template>
                            </el-table-column>
                        </el-table-column>
                        <el-table-column
                                prop="backDate"
                                label="内容/(应返还时间)"
                                align="center"
                                :render-header="renderheader"
                                header-align="center"
                                width="90"
                        ></el-table-column>
                        <el-table-column label="欠款未返还原因及工作推进情况">
                            <el-table-column
                                    prop="debtReason"
                                    label="预计进展情况"
                                    align="center"
                                    header-align="center"
                                    width="190"
                            ></el-table-column>
                        </el-table-column>
                        <el-table-column
                                prop="backExpectAmount"
                                label="任务目标/(预计收回金额)"
                                :render-header="renderheader"
                                align="center"
                                header-align="center"
                                width="130"
                        >
                            <template slot-scope="scope">
                                {{formatCurrency(scope.row[scope.column.property])}}
                            </template>
                        </el-table-column>
                        <el-table-column
                                prop="chargeUserName"
                                label="责任人"
                                align="center"
                                header-align="center"
                                width="60"
                        ></el-table-column>
                        <el-table-column
                                prop="backExpectDate"
                                label="预计回收时间"
                                align="center"
                                header-align="center"
                                width="100"
                        ></el-table-column>
                        <el-table-column
                                prop="backExpectPct"
                                label="回收比例"
                                align="center"
                                header-align="center"
                                width="80"
                        ></el-table-column>
                        <el-table-column
                                prop="comment"
                                label="备注"
                                align="center"
                                header-align="center"
                                width="100"
                        ></el-table-column>
                        <el-table-column
                                prop="checkInfo"
                                label="导入标识"
                                align="center"
                                header-align="center"
                                width="80"
                        ></el-table-column>
                    </el-table>
                </div>
                <span slot="footer" class="dialog-footer">
          <el-button @click="dialogVisible=false">取 消</el-button>
          <el-button type="primary" @click="dialogConfirm">确 定</el-button>
        </span>
            </el-dialog>
        </div>

        <!-- 导入数据源 -->
        <upload-dialog
                :isShow="showUploadDialog"
                @close="closeDialogAction"
                :isImportRelorPay="isImportReceiveDialog"
                @saveImportItems="saveImportItems"
        />
    </div>
</template>

<script>
    import {
        deleteAllReceive,
        doImportReceive,
        exportReceive,
        getMaxDateReceive,
        importReceive,
        getListReceive,
        getReceiveDropDownDept,
        exportExcelService2,
        getReceiveTemplate
    } from "../../services/dataCenterService";
    import UploadDialog from "./commonCell/UploadDialog"; //导入组件
    import echarts from 'echarts'

    export default {
        name: "accountsReceiveDataSource",
        components: {
            UploadDialog
        },
        data() {
            return {
                searchForm: {
                    enterDate: "",
                    deptName: ""
                },
                emptyData: [],
                maxDate: "",
                deptNameList: [],
                dialogVisible: false,
                dialogData: [],
                projectReceiveSubVOList: [],
                isImportReceiveDialog: true, //标记是否为导入应收账款数据源
                showUploadDialog: false, //对话框可见性
                sumTableData: [
                    {
                        projectName: "", //项目名称
                        debtCompany: "", //欠款单位
                        auditSituation: "", //审计及竣工情况
                        auditAmount: "0", //审计额或已完产值
                        collectedMoney: "0", //已收款
                        debtTotalMoney: "0", //应收账款
                        retentionMoney: "", //质保金
                        projectMoney: "", //需交工验收、审计、竣工验收后应支付工程款(不含质保金)
                        processMoney: "", //按进度应支付工程款(欠款总额-质保金-需交工验收、审计、竣工验收后应支付工程款)
                        withinOneYear: "", //1年以内
                        oneToTwo: "", //1-2年
                        twoToThree: "", //2-3年
                        beyondThree: "", //3年(含)以上
                        backDate: "", //内容(应返还时间)
                        debtReason: "", //预计进展情况
                        backExpectAmount: "", //"百日行动"任务目标/(预计收回金额)
                        chargeUserName: "", //责任人
                        backExpectDate: "", //预计回收时间
                        backExpectPct: "", //回收比例
                        comment: "" //备注
                    }
                ],
                pickerOptions: {
                    disabledDate: this.disabledDate
                }
            };
        },
        created() {
            let _this = this;
            //获取项目部
            getReceiveDropDownDept().then(res => {
                if (res.code === 10000000) {
                    this.deptNameList = res.data;
                    if (this.$route.params && this.$route.params.deptName) {
                        this.searchForm.deptName = this.$route.params.deptName;
                        this.$route.params.deptName = ''
                    }
                }
            }).catch(() => {
            });
            getMaxDateReceive().then(res => {
                if (res.code === 10000000) {
                    _this.searchForm.enterDate = res.data;
                    this.maxDate = res.data;
                    if (this.$route.params && this.$route.params.enterDate) {
                        this.searchForm.enterDate = this.$route.params.enterDate;
                        this.$route.params.enterDate = ''
                    }
                    this.search();
                }
            }).catch(() => {
            });
        },
        methods: {
            disabledDate(time) {
                // return time.getTime() > new Date(this.maxDate);
                return false;
            },
            //获取数据
            search() {
                getListReceive(this.searchForm).then(res => {
                    if (res.code === 10000000) {
                        this.projectReceiveSubVOList = res.data.projectReceiveSubVOList;
                        this.getSum(); //获取总计
                    } else {
                        this.$alert(res.msg, "提示", {
                            confirmButtonText: "确定",
                            type: "warning"
                        });
                    }

                });
            },
            resetData() {
                this.$refs["accountsReceiveDataSourceForm"].resetFields();
            },
            //删除
            deleteData() {
                this.$confirm("确定要删除吗?", "提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning"
                }).then(() => {
                    let params = {};
                    if (this.searchForm.enterDate) {
                        params.enterDate = this.searchForm.enterDate
                    } else {
                        this.$alert('请选择日期', "提示", {
                            confirmButtonText: "确定",
                            type: "warning"
                        });
                        return
                    }
                    deleteAllReceive(params).then(res => {
                        if (res.code === 10000000) {
                            this.$message.success("删除成功");
                        } else {
                            this.$alert(res.msg, "提示", {
                                confirmButtonText: "确定",
                                type: "warning"
                            });
                        }
                    });
                });
            },
            //下载模板
            exportPlatform() {
                getReceiveTemplate().then(
                    res => {
                        console.log(res);
                        if (res.code == 10000000) {
                            exportExcelService2(res.data).then(res1 => {
                                // this.$alert("成功", "提示", {
                                //   confirmButtonText: "确定"
                                // });
                            });
                        } else {
                            this.$alert(res.msg, "提示", {
                                confirmButtonText: "确定"
                            });
                        }
                    },
                    err => {
                        this.$message.error("系统异常");
                    }
                );
            },

            //导入
            importSubEngineer() {
                if (!this.searchForm.enterDate) {
                    this.$alert("请先选择日期，再导入数据。", "提示", {
                        confirmButtonText: "确定"
                    });
                    return
                }
                this.$confirm(
                    "确定要导入 " + this.searchForm.enterDate + " 数据吗",
                    "提示",
                    {
                        confirmButtonText: "确定",
                        cancelButtonText: "取消",
                        type: "warning"
                    }
                ).then(() => {
                    this.isImportReceiveDialog = true; //标记是否为应收账款数据源
                    this.showUploadDialog = true;
                });
            },
            //关闭导入对话框
            closeDialogAction() {
                this.showUploadDialog = false;
            },
            //显示导入数据
            saveImportItems(selectItems) {
                if (selectItems.length > 0) {
                    this.dialogVisible = true;
                    this.dialogData = selectItems;
                } else {
                    this.$alert("没有要导入的数据", "提示", {
                        confirmButtonText: "确定"
                    });
                }
            },
            dialogConfirm() {
                this.$confirm("确定要保存数据吗?", "提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning"
                }).then(() => {
                    let params = {};
                    params.enterDate = this.searchForm.enterDate;
                    params.projectReceiveVOList = this.dialogData;
                    doImportReceive(params)
                        .then(res => {
                            if (res.code === 10000000) {
                                this.dialogVisible = false;
                                this.$message.success("保存成功");
                            } else if (res.code >= 20000000) {
                                this.$alert(res.msg, "提示", {
                                    confirmButtonText: "确定",
                                    type: "warning"
                                });
                            } else {
                                this.$alert("系统异常", "提示", {
                                    confirmButtonText: "确定",
                                    type: "warning"
                                });
                            }
                        })
                        .catch(() => {
                            this.$alert("系统异常", "提示", {
                                confirmButtonText: "确定",
                                type: "warning"
                            });
                        });
                });
            },
            //导出
            exportExcele() {
                exportReceive(this.searchForm)
                    .then(res => {
                        if (res.code == 10000000) {
                            exportExcelService2(res.data).then(res1 => {
                                this.$alert("导出成功", "提示", {
                                    confirmButtonText: "确定"
                                });
                            });
                        } else if (res.code >= 20000000) {
                            this.$alert(res.msg, "提示", {
                                confirmButtonText: "确定"
                            });
                        } else {
                            this.$alert("系统异常", "提示", {
                                confirmButtonText: "确定"
                            });
                        }
                    })
                    .catch(() => {
                    });
            },
            //下载模板
            downLoadExcel() {
                console.log("暂时没有接口");
                // exportReceive().then(
                //     res => {
                //     },
                // );
            },
            //表格部分计算问题
            //表头文字分割
            renderheader(h, {column}) {
                return h("span", {}, [
                    h("span", {}, column.label.split("/")[0]),
                    h("br"),
                    h("span", {}, column.label.split("/")[1])
                ]);
            },
            //设置小计
            getSummaries(param) {
                let _this = this;
                const {columns, data} = param;
                const sums = [];
                columns.forEach((column, index) => {
                    if (index === 0) {
                        sums[index] = "小计";
                        return;
                    }
                    const values = data.map(item => Number(item[column.property]));
                    if (
                        !values.every(value => isNaN(value)) &&
                        (column.property == "auditAmount" ||
                            column.property == "collectedMoney" ||
                            column.property == "debtTotalMoney")
                    ) {
                        sums[index] = values.reduce((prev, curr) => {
                            const value = Number(curr);
                            if (!isNaN(value)) {
                                return prev + curr;
                            } else {
                                return prev;
                            }
                        }, 0);
                        // sums[index] += '';
                        sums[index] = _this.formatCurrency(sums[index]);
                    } else {
                        sums[index] = "";
                    }
                });
                return sums;
            },
            //数字用逗号隔开
            formatCurrency(num) {
                num = Number(num)
                num = num.toFixed(2)
                if (num === 0) {
                    return 0;
                } else if (num) {
                    num = num.toString().replace(/\$|\,/g, "");
                    if (num === "" || isNaN(num)) {
                        return 0;
                    }
                    var sign = "";
                    if (num.indexOf("-") !== -1) {
                        sign = "-";
                        num = num.substr(1);
                    }
                    var cents = num.indexOf(".") > 0 ? num.substr(num.indexOf(".")) : "";
                    cents = cents.length > 1 ? cents : "";
                    num = num.indexOf(".") > 0 ? num.substring(0, num.indexOf(".")) : num;
                    if (cents === "") {
                        if (num.length > 1 && num.substr(0, 1) === "0") {
                            return 0;
                        }
                    } else {
                        if (num.length > 1 && num.substr(0, 1) === "0") {
                            return 0;
                        }
                    }
                    for (var i = 0; i < Math.floor((num.length - (1 + i)) / 3); i++) {
                        num =
                            num.substring(0, num.length - (4 * i + 3)) +
                            "," +
                            num.substring(num.length - (4 * i + 3));
                    }
                    return sign + num + cents;
                }
            },
            // 获取汇总值
            getSum() {
                let sum = {
                    auditAmount: 0,
                    collectedMoney: 0,
                    debtTotalMoney: 0
                };
                this.projectReceiveSubVOList.forEach(item => {
                    sum.auditAmount += Number(item.auditAmountSub);
                    sum.collectedMoney += Number(item.collectedMoneySub);
                    sum.debtTotalMoney += Number(item.debtTotalMoneySub);
                });
                this.sumTableData[0]["auditAmount"] = this.formatCurrency(
                    sum.auditAmount
                );
                this.sumTableData[0]["collectedMoney"] = this.formatCurrency(
                    sum.collectedMoney
                );
                this.sumTableData[0]["debtTotalMoney"] = this.formatCurrency(
                    sum.debtTotalMoney
                );
            }
        }
    };
</script>

<style scoped lang="scss">
    .accountsReceiveDataSource {
        height: calc(100% - 20px);
        text-align: left;
        overflow: hidden;
        background: #ffffff;
        padding: 10px;

        .dialogWrap {
            height: 100%;

            /deep/ .el-dialog__wrapper {
                height: 90%;
                overflow: hidden;

                .el-dialog {
                    height: 100%;

                    .el-dialog__body {
                        height: 62%;
                        overflow: auto;
                    }
                }
            }

            .el-table {
                background: #f2f2f2;
                border: 1px solid #c8c8c8;
                /*表头*/
                /deep/ .el-table__header-wrapper {
                    .el-table__header thead tr th {
                        background: #ed7d31;
                        padding: 0;
                        border-color: #c8c8c8;

                        .cell {
                            text-align: center;
                            color: #ffffff;
                            line-height: 18px;
                        }
                    }
                }

                /*表格*/
                /deep/ .el-table__body-wrapper .el-table__body tbody tr td {
                    padding: 0;
                    margin-top: 10px;
                    border-bottom: 1px solid #c8c8c8;
                    border-right: 1px solid #c8c8c8;

                    .cell {
                        text-align: center;
                        line-height: 24px;
                        color: #666;
                    }
                }

                /*小计部分*/
                /deep/ .el-table__footer-wrapper {
                    margin-top: 10px;

                    .el-table__footer tbody tr td {
                        padding: 0;
                        background: #ffffff;
                        border-top: 1px solid #c8c8c8;
                        border-right: 1px solid #c8c8c8;

                        .cell {
                            text-align: center;
                        }
                    }
                }
            }
        }

        .uploadDiv {
            display: inline-block;
            margin: 0 10px;

            /deep/ .el-button span {
                font-size: 14px !important;
            }

            /deep/ .el-upload-list {
                display: none;
            }
        }

        .el-button--primary {
            background: #5b9bd5;
        }

        .btns {
            margin-bottom: 10px;
        }

        .el-form {
            border-bottom: 1px solid #dcdfe6;
        }

        .mainContentWrap {
            width: 100%;
            overflow: auto;
            height: calc(100% - 130px);

            .mainContent {
                width: 2154px;

                .cardBox {
                    margin-bottom: 20px;
                    /*box-shadow: 0 2px 12px 0 rgba(0, 0, 0, .1);*/
                    border: 1px solid #c8c8c8;
                    background-color: #f2f2f2;
                    padding: 10px;

                    /deep/ .el-table__empty-block {
                        background: #ffffff;
                    }

                    .el-button {
                        margin-bottom: 15px;
                    }

                    .el-table {
                        background: #f2f2f2;
                        border: 1px solid #c8c8c8;
                        /*表头*/
                        /deep/ .el-table__header-wrapper {
                            .el-table__header thead tr th {
                                background: #ed7d31;
                                padding: 0;
                                border-color: #c8c8c8;

                                .cell {
                                    text-align: center;
                                    color: #ffffff;
                                    line-height: 18px;
                                }
                            }
                        }

                        /*表格*/
                        /deep/ .el-table__body-wrapper .el-table__body tbody tr td {
                            padding: 0;
                            margin-top: 10px;
                            border-bottom: 1px solid #c8c8c8;
                            border-right: 1px solid #c8c8c8;

                            .cell {
                                text-align: center;
                                line-height: 24px;
                                color: #666;
                            }
                        }

                        /*小计部分*/
                        /deep/ .el-table__footer-wrapper {
                            margin-top: 10px;

                            .el-table__footer tbody tr td {
                                padding: 0;
                                background: #ffffff;
                                border-top: 1px solid #c8c8c8;
                                border-right: 1px solid #c8c8c8;

                                .cell {
                                    text-align: center;
                                }
                            }
                        }
                    }
                }

                .sumBox {
                    /deep/ .el-table .el-table__body-wrapper .el-table__body tbody tr td {
                        border: 1px solid #ebeef5;

                        .cell {
                            line-height: 36px;
                        }
                    }
                }
            }
        }
    }
</style>

